// MeterInventoryLanding.tsx - Updated with real API integration
import React, { useState } from "react";
import { Building, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MeterTabs } from "./MeterTabs";
import { KpiCards } from "./KpiCards";

import { Button } from "@shared/ui/button";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";

export const MeterInventoryLanding: React.FC = () => {
  const navigate = useNavigate();
  const remoteUtilityId = getRemoteUtilityId();
  usePageViewTimer({pageName: 'MX Meter Manufacturer Dashboard'});
  // Simplified state management - routing handles navigation
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Navigation handlers
  const handleAddMeterModel = () => {
    navigate('/mx/manufacturer/add');
  };

  const handleManageManufacturers = () => {
    navigate('/mx/manufacturer/manufacturers');
  };

  const handleDeleteMeter = async (id: string) => {
  };

  // Error display component
  const ErrorMessage = ({ message, onDismiss }: { message: string; onDismiss: () => void }) => (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="text-red-600 mr-2">⚠️</div>
          <span className="text-red-800">{message}</span>
        </div>
        <button
          onClick={onDismiss}
          className="text-red-600 hover:text-red-800"
        >
          ✕
        </button>
      </div>
    </div>
  );

  return (
    <div className="">
      {/* Error Message */}
      {error && (
        <ErrorMessage
          message={error}
          onDismiss={() => setError(null)}
        />
      )}

      {/* Header Section */}
      <div className="flex items-center justify-between mb-6 pb-4 border-gray-200">
        <div>
          <h1 className="page-title">
            Meter Model Management
          </h1>
          <p className="page-subtitle">
            Manage meter manufacturers, models, and specifications
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={handleManageManufacturers}
            disabled={loading}
          >
            <Building className="h-4 w-4" />
            Manage Manufacturers
          </Button>
          <Button
            className="flex items-center gap-2"
            onClick={handleAddMeterModel}
            disabled={loading}
          >
            <Plus className="h-4 w-4" />
            Add New Meter Model
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <KpiCards remote_utility_id={remoteUtilityId} />


      {/* Meter Tabs and Table */}
      <MeterTabs
        onDelete={handleDeleteMeter}
        loading={loading}
        searchValue={searchValue}
      />
    </div>
  );
};